import React, { useMemo } from 'react'
import Stack from '@mui/material/Stack'
import { Field, useFormikContext } from 'formik'
import Typography from '@mui/material/Typography'
import FormHelperText from '@mui/material/FormHelperText'

import { ImportUtilityModel } from '../../typings'
import { TidalTextFormikField } from '@sales-center/components'
import { DebouncedTextField } from '@user/components/Formik/DebouncedTextField'

export function NameAndDescription() {
  const {
    values: { name, description },
    errors,
    submitCount,
  } = useFormikContext<ImportUtilityModel>()

  const isNameError = useMemo(
    () => (submitCount > 0 && errors.name ? true : false),
    [errors.name, submitCount],
  )

  const nameIsEmpty = useMemo(
    () => (submitCount > 0 && name?.trim().length === 0 ? true : false),
    [name, submitCount],
  )

  return (
    <Stack gap={1.6} mb={3}>
      <Typography variant="h7">Import Name*</Typography>
      <Stack>
        <Stack position={'relative'}>
          <Field
            name="name"
            label="Import Name"
            helperText="Create a unique name. Name must be between 5 and 50 characters."
            required
            avoidValidateOnBlur
            inputProps={{ maxLength: 50 }}
            component={DebouncedTextField}
          />

          <FormHelperText
            error={isNameError}
            sx={{
              position: 'absolute',
              bottom: 0,
              right: 15,
            }}
          >
            {name?.length}/50
          </FormHelperText>
        </Stack>
        <Stack>
          <FormHelperText
            hidden={!nameIsEmpty}
            sx={{ ml: 1.4 }}
            error={nameIsEmpty}
          >
            Required*
          </FormHelperText>
        </Stack>
      </Stack>
      <Stack position={'relative'}>
        <TidalTextFormikField
          name="description"
          label="Description"
          inputProps={{ maxLength: 150 }}
        />
        <FormHelperText sx={{ ml: 1.4 }}>
          Add details about this import for future reference.
        </FormHelperText>
        <FormHelperText
          sx={{
            position: 'absolute',
            bottom: 0,
            right: 15,
          }}
        >
          {description?.length}/150
        </FormHelperText>
      </Stack>
    </Stack>
  )
}
